import { getVID, parseQuery } from './utils';
import { platformName } from './ua';
import { addUidInUrl } from './user-id';

const query = parseQuery();
const $$link = document.querySelectorAll('a[href^="/download/"]');
const $agreeCheckbox = document.getElementById('agree-checkbox');

const getDownloadUrl = (platform) => {
  let url = `/download/?platform=${platform}`;

  if (window.location.search) {
    const search = window.location.search.replace(/^\?/, '');

    url += `&${search}`;
  }

  if (!query.vid) {
    const vid = getVID(query);

    if (vid) {
      url += `&vid=${vid}`;
    }
  }

  url = addUidInUrl(url);

  return url;
};

$$link.forEach(($link) => {
  if (!$link.dataset.platform) {
    $link.dataset.platform = platformName;
  }

  if ($link.dataset.platform) {
    $link.href = getDownloadUrl($link.dataset.platform);
  } else {
    $link.style.display = 'none';
  }
});

gtag("get", "G-ZSV21369ML", "client_id", (clientId) => {
  if (clientId) {
    $$link.forEach(($link) => {
      $link.href = addUidInUrl($link.getAttribute("href"), clientId);
    });
  }
});

if ($agreeCheckbox) {
  $agreeCheckbox.addEventListener('change', (event) => {
    $$link.forEach(($link) => {
      $link.classList.toggle('disabled', !event.currentTarget.checked);
    });
  });
}
